import {
  AdditionalShiftActivityStatusFilter,
  ShiftActivityStatus,
  ShiftActivityStatusTranslationMap,
} from '@wilson/interfaces';
import { FilterOptions } from '../../options.interface';

export const ShiftActivityFilterOptions: FilterOptions[] = [
  {
    id: ShiftActivityStatus.NotOccupied,
    name: ShiftActivityStatusTranslationMap[ShiftActivityStatus.NotOccupied],
  },
  {
    id: ShiftActivityStatus.NotReleased,
    name: ShiftActivityStatusTranslationMap[ShiftActivityStatus.NotReleased],
  },
  {
    id: AdditionalShiftActivityStatusFilter.Released,
    name: ShiftActivityStatusTranslationMap[
      AdditionalShiftActivityStatusFilter.Released
    ],
  },
];
